export default __webpack_public_path__ + "static/media/kas.e0dd626d.webp";